var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHighBatterySvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "25px",
    viewBox: "0 0 1024 1024",
    className: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M725.333333 938.666667H298.666667c-23.466667 0-42.666667-19.2-42.666667-42.666667V170.666667c0-23.466667 19.2-42.666667 42.666667-42.666667h426.666666c23.466667 0 42.666667 19.2 42.666667 42.666667v725.333333c0 23.466667-19.2 42.666667-42.666667 42.666667z",
    fill: "#7AB934"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M597.333333 277.333333h-170.666666c-12.8 0-21.333333-8.533333-21.333334-21.333333V106.666667c0-12.8 8.533333-21.333333 21.333334-21.333334h170.666666c12.8 0 21.333333 8.533333 21.333334 21.333334v149.333333c0 12.8-8.533333 21.333333-21.333334 21.333333z",
    fill: "#CFD8DC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M725.333333 938.666667H298.666667c-23.466667 0-42.666667-19.2-42.666667-42.666667V277.333333h512v618.666667c0 23.466667-19.2 42.666667-42.666667 42.666667z",
    fill: "#8BC34A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighBatterySvgrepoCom);
export default __webpack_public_path__ + "static/media/high-battery-svgrepo-com.5c5bf99909a9ec8c0c17e6fad91fbb02.svg";
export { ForwardRef as ReactComponent };